export default {
  extract: [],
  resume: {},
  queryParams: {
    endAt: null,
    filter: null,
    startAt: null,
    rowsPerPage: 15,
    startRow: 0,
    rowsNumber: 0
  }
};
